import { useQuery } from '@tanstack/react-query';
import { fetchBankInfo } from './api';

export const BANK_INFO_KEY = ['settings', 'banking'] as const;

export function useBankInfo(enabled = true) {
  return useQuery({
    queryKey: BANK_INFO_KEY,
    queryFn: fetchBankInfo,
    enabled,
  });
}
